import { render, staticRenderFns } from "./EditOrganizationComponent.vue?vue&type=template&id=79b2cec0"
import script from "./EditOrganizationComponent.vue?vue&type=script&lang=js"
export * from "./EditOrganizationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports